import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import { User, ButtonsGroup, Offer } from '../../components';
import {
  renderSphereObject,
  renderCastingCategoriesObject,
} from '../../services/functions';
import {
  Button, Container, Icon, Loader,
} from '../../ui-kit';
import './styles.scss';

const CurrentUserView = (props) => (
  <>
    <ButtonsGroup
      loading={props.userDataLoading || props.userСastingsLoading}
      activeTabIndex={props.activeTab}
      badges={[
        {
          name: 'User data',
        },
        {
          name: 'Castings',
        },
      ]}
      setActiveTab={(index) => props.setActiveTab(index)}
      refreshAction={() => props.refreshAction()}
    />
    {props.userDataLoading || props.userСastingsLoading ? (
      <div className="users_page_loader__block">
        <Loader type="big-loader" />
      </div>
    ) : (
      <div className="user_castings__container">
        {props.activeTab === 0 && (
          <div className="user_data__container">
            <div className="user_basic_data__container">
              <User
                name={props.userData.name}
                lastName={props.userData.lastname}
                avatar={props.userData.avatar?.uri}
                gender={props.userData.gender}
                role={props.userData.role}
                position={props.userData.position}
                phone={props.userData.phone}
                email={props.userData.email}
                height={props.userData.height}
                weight={props.userData.weight}
                breast={props.userData.breast}
                waist={props.userData.waist}
                thigh={props.userData.thigh}
                clothingSize={props.userData.clothingSize}
                shoeSize={props.userData.shoeSize}
                hairСolor={props.userData.hairСolor}
                appearanceType={props.userData.appearanceType}
                languages={props.userData.languages}
                country={props.userData.country}
                age={props.userData.birthDate}
                interest={
                props.userData.interests
                && props.renderCategoriesObject(props.userData.interests)
              }
                photos={props.userData.photos}
                description={props.userData.description}
              />
              {props.userData.role === 'applicant' && (
                <Container className="current_user_full_v_container">
                  <div className={`current_user_full_v_content ${props.fullVLoader || (props.userData.subscribe && props.userData.subscribe.type === 'purchase' && props.userData.subscribe.status)
                    ? 'current_user_full_v_loading'
                    : ''}`}
                  >
                    <p>
                      {props.userData.subscribe && props.userData.subscribe.status
                        ? 'This user has the full version of the app. You can turn off the full version manually.'
                        : 'This user doesn’t have the full version of the app. You can enable the full version manually.'}
                    </p>
                    <Button
                      value={props.userData.subscribe && props.userData.subscribe.status ? 'Turn off the full version' : 'Enable the full version'}
                      onClick={() => props.giveOutFullVersion(props.userData.uid)}
                    />
                  </div>
                  <div
                    className={`
                        current_user_cart__container
                        ${props.userData.subscribe && props.userData.subscribe.status
                      ? 'current_user_cart_green'
                      : 'current_user_cart_red'}
                      ${props.fullVLoader || (props.userData.subscribe && props.userData.subscribe.type === 'purchase')
                        ? 'current_user_full_v_loading'
                        : ''}`}
                  >
                    <Icon name={props.userData.subscribe && props.userData.subscribe.status ? 'cart-yes' : 'cart-not'} />
                  </div>
                  {props.fullVLoader && (
                    <div className="current_user_full_v_loader">
                      <Loader type="small-loader" />
                    </div>
                  )}
                  {props.userData.subscribe && props.userData.subscribe.type === 'purchase' && props.userData.subscribe.status && (
                    <div className="current_user_full_v_loader">
                      <Icon name="lock-closed" />
                    </div>
                  )}
                </Container>
              )}
            </div>
            <div className="second__container">
              {props.companyData?.map((e) => (
                <Container className="represent_company__container">
                  <div className="represent_company_background__container">
                    <div
                      style={{
                        backgroundImage: `url(${e.logo?.uri ? e.logo.uri : require('../../images/background.png')})`,
                        backgroundPosition: 'center',
                        backgroundRepeat: 'no-repeat',
                        backgroundSize: 'cover',
                      }}
                      className="represent_company_background"
                    />
                    <div className="represent_company_data__conatainer">
                      {!e.logo ? (
                        <div
                          className="represent_company_avatar"
                          style={{
                            backgroundColor: 'rgba(77, 204, 197, 0.1)',
                          }}
                        >
                          <Icon name="camera" />
                        </div>
                      ) : (
                        <Link
                          to={`/company#${e.companyId}`}
                          className="represent_company_avatar"
                          style={{
                            backgroundImage: `url(${e.logo?.uri})`,
                            backgroundPosition: 'center',
                            backgroundRepeat: 'no-repeat',
                            backgroundSize: 'cover',
                            backgroundColor: 'rgba(77, 204, 197, 0.1)',
                          }}
                        />
                      )}
                      <div className="represent_company_data">
                        <Link to={`/company#${e.companyId}`} className="represent_company_name">{e.name}</Link>
                        <span className="represent_company_text">
                          Phone:
                          {' '}
                          {e.phone}
                        </span>
                      </div>
                    </div>
                  </div>
                </Container>
              ))}
            </div>
          </div>
        )}

        {props.activeTab === 1
          && props.userCastings
          && props.userCastings.data.length > 0
          && props.categories.success
          && props.userCastings.data.map((item) => (
            <Offer
              feedbacks={item.feedbacks}
              views={item.newReview}
              actionsDisabled
              name={item.title}
              description={item.description}
              status={item.status}
              dueDate={item.contract.dueDate}
              currency={item.contract.currency}
              payment={item.contract.amount}
              creatorId={item.creatorId}
              location={item.place}
              id={item.castingId}
              image={item.avatar}
              age={item.age}
              gender={item.gender}
              type={item.contract.type}
              photos={item.photos}
              sphere={renderSphereObject(item.mainCategory, props.categories)}
              category={renderCastingCategoriesObject(
                renderSphereObject(item.mainCategory, props.categories),
                item.category,
              )}
              requirements={item.requirements}
              createdTime={item.createdTime}
            />
          ))}

        {props.activeTab === 1
          && props.userCastings
          && props.userCastings.data.length === 0 && (
            <div className="user_castins_empty__container">
              <div className="user_castings_empty">
                <p>The user has no castings yet</p>
              </div>
            </div>
        )}
      </div>
    )}
  </>
);

CurrentUserView.propTypes = {
  userData: PropTypes.object,
  userDataLoading: PropTypes.bool,
  renderCategoriesObject: PropTypes.func,
  setActiveTab: PropTypes.func,
  activeTab: PropTypes.number,
  userСastingsLoading: PropTypes.bool,
  categories: PropTypes.object,
  userCastings: PropTypes.object,
  refreshAction: PropTypes.func,
  giveOutFullVersion: PropTypes.func,
  fullVLoader: PropTypes.bool,
  companyData: PropTypes.object,
};

CurrentUserView.defaultProps = {
  userData: {},
  userDataLoading: false,
  renderCategoriesObject: () => {},
  setActiveTab: () => {},
  giveOutFullVersion: () => {},
  activeTab: 0,
  userСastingsLoading: false,
  categories: {},
  userCastings: undefined,
  refreshAction: () => {},
  fullVLoader: false,
  companyData: null,
};

export default CurrentUserView;
